import { STRATEGIES } from "@/data/strategies";
import { Card } from "@/components/ui/card";
import { ChevronRight, BookOpen } from "lucide-react";

export function StrategiesListPage({ lang, onSelect }) {
  const isAr = lang === "ar";
  return (
    <div dir={isAr ? "rtl" : "ltr"} className="space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <BookOpen className="w-6 h-6 text-pink-500" />
        <h1 className="text-xl sm:text-2xl font-extrabold text-pink-600">
          {isAr ? "دليل الاستراتيجيات" : "Trading Strategies Guide"}
        </h1>
        <span className="text-xs sm:text-sm text-zinc-500 ml-2">
          {STRATEGIES.length} {isAr ? "استراتيجية" : "strategies"}
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {STRATEGIES.map((s) => {
          const Icon = s.icon;
          return (
            <Card
              key={s.id}
              onClick={() => onSelect(s.id)}
              className="cursor-pointer bg-white border-2 border-pink-200 hover:border-pink-400 hover:shadow-lg hover:shadow-pink-200/60 hover:scale-[1.02] transition-all rounded-2xl overflow-hidden"
              data-testid={`strategy-card-${s.id}`}
            >
              <div className={`h-2 bg-gradient-to-r ${s.color}`} />
              <div className="p-4">
                <div className="flex items-start gap-3">
                  <div className={`shrink-0 w-12 h-12 rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center shadow-md`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="font-bold text-sm sm:text-base text-zinc-800 leading-tight">
                      {s.name[lang] || s.name.en}
                    </h2>
                    <p className="text-xs text-zinc-500 mt-1 line-clamp-2 leading-relaxed">
                      {s.summary[lang] || s.summary.en}
                    </p>
                  </div>
                  <ChevronRight className={`w-5 h-5 text-pink-400 shrink-0 mt-1 ${isAr ? "rotate-180" : ""}`} />
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
